'use es6';

import keyMirror from 'react-utils/keyMirror';
export default Object.freeze(keyMirror({
  ADVANCED_MENUS_MENU_NODE: null
}));